import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Award, Quote } from 'lucide-react';
import { Section } from './ui/Section';
export function ExpertSection() {
  return <Section background="cream" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-md border border-[#2C7A7B]/10 relative" data-id="element-35">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-[#D4AF37]/20 rotate-180" data-id="element-36" />

          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 relative z-10" data-id="element-37">
            <div className="flex-shrink-0" data-id="element-38">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-[#FFF9F5] shadow-lg" data-id="element-39">
                <img src="https://cdn.magicpatterns.com/uploads/tZ7GAySu5KDM3tKefiLQ44/4.webp" alt="Dra. Sofía Herrera - Ingeniera en Higiene Ambiental" className="w-full h-full object-cover" loading="lazy" data-id="element-40" />
              </div>
            </div>

            <div className="text-center md:text-left" data-id="element-41">
              <div className="inline-flex items-center gap-2 bg-[#2C7A7B]/10 text-[#2C7A7B] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-42">
                <Award className="w-3 h-3" data-id="element-43" />
                Respaldo Experto
              </div>

              <blockquote className="text-xl md:text-2xl font-serif text-gray-800 italic mb-6 leading-relaxed" data-id="element-44">
                "El principio activo doble y la secuencia de 15 minutos
                mantienen los agentes limpiadores trabajando por días, no solo
                horas."
              </blockquote>

              <div data-id="element-45">
                <cite className="not-italic font-bold text-gray-900 block text-lg" data-id="element-46">
                  Dra. Sofía Herrera
                </cite>
                <span className="text-gray-500 text-sm" data-id="element-47">
                  Ingeniera en Higiene Ambiental
                </span>
                <p className="text-xs text-gray-400 mt-2" data-id="element-48">
                  Reseña voluntaria — no patrocinada
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}